import script from "./specific-gravity-list.vue?vue&type=script&setup=true&lang=js"
export * from "./specific-gravity-list.vue?vue&type=script&setup=true&lang=js"

import "./specific-gravity-list.vue?vue&type=style&index=0&id=77c0074d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c0074d"]])

export default __exports__